/**
 * Service for WebRTC compute plan configurations
 * Contains static mappings of available WebRTC plan types and their GPU specifications
 */

/**
 * Available WebRTC compute plans with their GPU configurations
 * @returns {Object} Map of plan names to their configurations
 */
export function getWebrtcPlans() {
    return {
        "webrtc-cpu": {},
        "webrtc-gpu-small": { gpu: "T4" },
        "webrtc-gpu-medium": { gpu: "L4" },
        "webrtc-gpu-large": { gpu: "L40S" }
    };
}

/**
 * WebRTC plan billing rates in credits per hour
 */
export const WEBRTC_PLAN_RATES = {
    "webrtc-cpu": 0.1,
    "webrtc-gpu-small": 0.75,
    "webrtc-gpu-medium": 1,
    "webrtc-gpu-large": 2
};

/**
 * Default WebRTC plan used when no plan is specified or an invalid plan is provided
 */
export const DEFAULT_WEBRTC_PLAN = "webrtc-gpu-small";

/**
 * Get the credit conversion rate for a WebRTC plan.
 * Returns the number of credits per second.
 * @param {string} plan - WebRTC plan name (e.g., "webrtc-gpu-small")
 * @returns {number|null} Conversion rate (credits per second) or null if plan not found
 */
export function getWebrtcPlanConversionRate(plan) {
    const creditsPerHour = WEBRTC_PLAN_RATES[plan];
    if (creditsPerHour === undefined) {
        return null;
    }
    return creditsPerHour / 3600;
}
